export function getQueryStringFromParams(params: Record<string, unknown>): string {
  const paramsQueryString = Object.entries(params).reduce(
    (accumulator, [key, value]) => {
      if (value === undefined || value === null) {
        return accumulator;
      }
      const separator = accumulator?.length ? '&' : '';
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      return `${accumulator}${separator}${key}=${encodeURIComponent(stringValue)}`;
    },
    ''
  );
  return paramsQueryString;
}
